import { PostProperties } from "../types";
import image from "../img/lostGemAaronCarl.jpg";

const post: PostProperties = {
  id: 23,
  title: "Aaron Carl (Live) - Fuse-in, Detroit (28.05.2005)",
  content: `Originally titled "Aaron Carl and Friends Live" this absolute gem of a live performance comes from one of the pillars of Detroit music - Aaron Carl. Performed in 2005, this mix showcases Aaron's enormous talent. Further information about this performance as well as a video can be found on vimeo. R.I.P`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/aaron-carl-live-fuse-in-detroit-28-05-2005",
  category: "Lost Gem",
  translationsBg: {
    content: `Оригинално озаглавен "Aaron Carl and Friends Live", това е абсолютен скъпоценен запис от живо изпълнение на един от стълбовете на детройтската музика – Aaron Carl. Изпълнен през 2005 г., миксът демонстрира огромния му талант. Допълнителна информация и видео могат да бъдат намерени във Vimeo. R.I.P`,
  },
};

export default post;
